import List from 'ui/Element/List'
import ListActionsHOC from 'platform/react/hoc/list/actions'

const ActionsList = ListActionsHOC(List)

export default ActionsList
